export default "__VITE_ASSET__747744af__"